/* eslint-disable no-restricted-syntax */
export const discountTypes = {
  fixed: {
    id: "fixed",
    value: "fix_amount",
    name: "Fixed Amount Discount",
    amount: 0,
    percentPoint: 0,
    description: "Fixed Discount Amount",
    default: true
  },
  percent: {
    id: 'percent',
    value: "fix_percent",
    name: "Percentage Discount",
    amount: 0,
    percentPoint: 0,
    description: "Percentage Discount Amount",
    default: false
  }
}

export const getDefaultDiscountType = () => {

  for (const [key, value] of Object.entries(discountTypes)) {
    // console.log(`${key}: ${value}`);
    if(value.default) return value
  }

  return false
}

export const getDiscountTypeByValue = (val) => {

  for (const [key, value] of Object.entries(discountTypes)) {
    // console.log(`${key}: ${value}`);
    if(value.value === val) return value
  }

  return false
}